import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@bliks-io/ui';

export interface EntityPickerCellProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  /** Body content rendered below the headline (typically an `EntityPickerList`). */
  children?: ReactNode;
  className?: string;
}

export function EntityPickerCell({
  icon: Icon,
  label,
  onClick,
  children,
  className
}: EntityPickerCellProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'bg-bg-1 border border-border-14 rounded-lg p-2 text-left w-full',
        'hover:border-line-strong transition-colors',
        className
      )}
    >
      <div className="flex items-center gap-1.5">
        <Icon className="h-3 w-3 text-muted-foreground" />
        <span className="text-2xs font-semibold uppercase tracking-wide text-muted-foreground">
          {label}
        </span>
      </div>
      {children}
    </button>
  );
}
